import React from 'react'
import ba1 from "../../assets/images/ba1.jpeg"
import "./Pictures.css"
function Pictures() {
    return (
        <div className='pic'>
            <img src={ba1} alt="chart 1" />
        </div>
    )
}

export default Pictures